export const mapStyle = [{
  'featureType': 'land',
  'elementType': 'geometry',
  'stylers': {
    'color': '#081734'
  }
},
{
  'featureType': 'building',
  'elementType': 'geometry',
  'stylers': {
    'color': '#04406F'
  }
},
{
  // 调整建筑物标签是否可视
  'featureType': 'building',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'on'
  }
},
{
  // 调整高速道路颜色
  'featureType': 'highway',
  'elementType': 'geometry',
  'stylers': {
    'color': '#015B99'
  }
},
{
  // 调整高速名字是否可视
  'featureType': 'highway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  // 调整一些干道颜色
  'featureType': 'arterial',
  'elementType': 'geometry',
  'stylers': {
    'color': '#003051'
  }
},
{
  'featureType': 'arterial',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'green',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'water',
  'elementType': 'geometry',
  'stylers': {
    'color': '#044161'
  }
},
{
  // 调整地铁颜色
  'featureType': 'subway',
  'elementType': 'geometry.stroke',
  'stylers': {
    'color': '#003051'
  }
},
{
  'featureType': 'subway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'railway',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'railway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  // 调整所有的标签的边缘颜色
  'featureType': 'all',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#081734'
  }
},
{
  // 调整所有标签的填充颜色
  'featureType': 'all',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': '#081734'
  }
},
{
  'featureType': 'manmade',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'manmade',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'local',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'local',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'subway',
  'elementType': 'geometry',
  'stylers': {
    'lightness': -65
  }
},
{
  'featureType': 'railway',
  'elementType': 'all',
  'stylers': {
    'lightness': -40
  }
},
{
  'featureType': 'boundary',
  'elementType': 'geometry',
  'stylers': {
    'color': '#8b8787',
    'weight': '1',
    'lightness': -29
  }
}]

export const mapStyle2 = [{
  'featureType': 'land',
  'elementType': 'geometry',
  'stylers': {
    'color': '#00182f'
  }
},
{
  'featureType': 'building',
  'elementType': 'geometry',
  'stylers': {
    'color': '#00182f'
  }
},
{
  // 调整建筑物标签是否可视
  'featureType': 'building',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'on'
  }
},
{
  // 调整高速道路颜色
  'featureType': 'highway',
  'elementType': 'geometry',
  'stylers': {
    'color': '#015B99'
  }
},
{
  // 调整高速名字是否可视
  'featureType': 'highway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  // 调整一些干道颜色
  'featureType': 'arterial',
  'elementType': 'geometry',
  'stylers': {
    'color': '#003051'
  }
},
{
  'featureType': 'arterial',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'green',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'water',
  'elementType': 'geometry',
  'stylers': {
    'color': '#044161'
  }
},
{
  // 调整地铁颜色
  'featureType': 'subway',
  'elementType': 'geometry.stroke',
  'stylers': {
    'color': '#003051'
  }
},
{
  'featureType': 'subway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'railway',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'railway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  // 调整所有的标签的边缘颜色
  'featureType': 'all',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#00182f'
  }
},
{
  // 调整所有标签的填充颜色
  'featureType': 'all',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': '#fff'
  }
},
{
  'featureType': 'city',
  'elementType': 'labels.icon',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'manmade',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'manmade',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'local',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'local',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'subway',
  'elementType': 'geometry',
  'stylers': {
    'lightness': -65,
    'color': 'rgba(0,0,0,0)'
  }
},
{
  'featureType': 'railway',
  'elementType': 'all',
  'stylers': {
    'lightness': -40,
    'color': 'rgba(0,0,0,0)'
  }
},
{
  'featureType': 'boundary',
  'elementType': 'geometry',
  'stylers': {
    'color': 'rgba(0,0,0,0)',
    'weight': '1',
    'lightness': -29
  }
},
{
  'featureType': 'districtlabel',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': '#eeeeee00'
  }
},
{
  'featureType': 'districtlabel',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#ffffff00'
  }
},
{
  'featureType': 'districtlabel',
  'elementType': 'labels.icon',
  'stylers': {
    'visibility': 'off'
  }
}]

export const mapStyleGas = [{
  'featureType': 'road',
  'elementType': 'all',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'poilabel',
  'elementType': 'all',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'background',
  'elementType': 'all',
  'stylers': {
    'color': '#010c48',
    'visibility': 'on'
  }
},
{
  'featureType': 'districtlabel',
  'elementType': 'all',
  'stylers': {
    'color': '#ff0000ff',
    'visibility': 'off'
  }
},
{
  'featureType': 'boundary',
  'elementType': 'all',
  'stylers': {
    'color': '#3d71c4ff',
    'visibility': 'off'
  }
}]

let sColor = '#d8dae0ff'

export const mapStyle1 = [{
  'featureType': 'land',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'on',
    'color': '#ffffffff'
  }
},
{
  'featureType': 'poilabel',
  'elementType': 'all',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'manmade',
  'elementType': 'all',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'building',
  'elementType': 'all',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'highway',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'on',
    'weight': 1
  }
},
{
  'featureType': 'highway',
  'elementType': 'geometry.fill',
  'stylers': {
    'color': sColor
  }
},
{
  'featureType': 'highway',
  'elementType': 'geometry.stroke',
  'stylers': {
    'color': sColor
  }
},
{
  'featureType': 'highway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'on'
  }
},
{
  'featureType': 'highway',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': sColor
  }
},
{
  'featureType': 'highway',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#ffffffff'
  }
},
{
  'featureType': 'highway',
  'elementType': 'labels.icon',
  'stylers': {
    'visibility': 'on'
  }
},
{
  'featureType': 'arterial',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'on',
    'weight': 1
  }
},
{
  'featureType': 'arterial',
  'elementType': 'geometry.fill',
  'stylers': {
    'color': sColor
  }
},
{
  'featureType': 'arterial',
  'elementType': 'geometry.stroke',
  'stylers': {
    'color': sColor
  }
},
{
  'featureType': 'arterial',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'on'
  }
},
{
  'featureType': 'arterial',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': '#525355ff'
  }
},
{
  'featureType': 'arterial',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#ffffffff'
  }
},
{
  'featureType': 'local',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'on',
    'weight': 1
  }
},
{
  'featureType': 'local',
  'elementType': 'geometry.fill',
  'stylers': {
    'color': sColor
  }
},
{
  'featureType': 'local',
  'elementType': 'geometry.stroke',
  'stylers': {
    'color': '#ffffffff'
  }
},
{
  'featureType': 'local',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'on'
  }
},
{
  'featureType': 'local',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': '#979c9aff'
  }
},
{
  'featureType': 'local',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#ffffffff'
  }
},
{
  'featureType': 'railway',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'on',
    'weight': 1
  }
},
{
  'featureType': 'railway',
  'elementType': 'geometry.fill',
  'stylers': {
    'color': '#949494ff'
  }
},
{
  'featureType': 'railway',
  'elementType': 'geometry.stroke',
  'stylers': {
    'color': '#ffffffff'
  }
},
{
  'featureType': 'subway',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'on',
    'weight': 1
  }
},
{
  'featureType': 'subway',
  'elementType': 'geometry.fill',
  'stylers': {
    'color': sColor
  }
},
{
  'featureType': 'subway',
  'elementType': 'geometry.stroke',
  'stylers': {
    'color': '#ffffffff'
  }
},
{
  'featureType': 'subway',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'on'
  }
},
{
  'featureType': 'subway',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': '#979c9aff'
  }
},
{
  'featureType': 'subway',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#ffffffff'
  }
},
{
  'featureType': 'continent',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'on'
  }
},
{
  'featureType': 'continent',
  'elementType': 'labels.icon',
  'stylers': {
    'visibility': 'on'
  }
},
{
  'featureType': 'continent',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': '#333333ff'
  }
},
{
  'featureType': 'continent',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#ffffffff'
  }
},
{
  'featureType': 'city',
  'elementType': 'labels.icon',
  'stylers': {
    'visibility': 'on'
  }
},
{
  'featureType': 'city',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'on'
  }
},
{
  'featureType': 'city',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': '#454d50ff'
  }
},
{
  'featureType': 'city',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#ffffffff'
  }
},
{
  'featureType': 'town',
  'elementType': 'labels.icon',
  'stylers': {
    'visibility': 'on'
  }
},
{
  'featureType': 'town',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'on'
  }
},
{
  'featureType': 'town',
  'elementType': 'labels.text.fill',
  'stylers': {
    'color': sColor
  }
},
{
  'featureType': 'town',
  'elementType': 'labels.text.stroke',
  'stylers': {
    'color': '#ffffffff'
  }
},
{
  'featureType': 'road',
  'elementType': 'labels',
  'stylers': {
    'visibility': 'off'
  }
},
{
  'featureType': 'road',
  'elementType': 'geometry.fill',
  'stylers': {
    'color': sColor
  }
},
{
  'featureType': 'road',
  'elementType': 'geometry.stroke',
  'stylers': {
    'color': '#ffffff1'
  }
}]

export const mapStyleMap = [{
  'featureType': 'road',
  'elementType': 'geometry',
  'stylers': {
    'weight': 1
  }
},
{
  'featureType': 'road',
  'elementType': 'geometry.stroke',
  'stylers': {
    'color': '#00000000'
  }
},
{
  'featureType': 'arterial',
  'elementType': 'geometry',
  'stylers': {
    'visibility': 'on',
    'weight': 1
  }
}]



// WEBPACK FOOTER //
// ./src/cllib/map_style.js